import { Component, OnInit, AfterViewInit, ViewChild, OnDestroy, ViewChildren, HostListener, ElementRef, TemplateRef, Renderer2, Output, EventEmitter, Inject } from '@angular/core';
import { UserGroupService } from 'src/app/core/services/user-group.service';
import { MatDialogRef, MatDialog, MatExpansionPanel, MatSelect, MAT_DIALOG_DATA } from '@angular/material';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { ReplaySubject, Subject, Subscription } from 'rxjs';
import { FormControl, NgForm } from '@angular/forms';
import { NotificationService } from 'src/app/core/services/notification.service';
import { first, map, takeUntil } from 'rxjs/operators';
import { DeactivationGuarded } from 'src/app/core/guards/confirm-deactivate.guard';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/core/services/api.service';
import { CommonService } from 'src/app/core/services/common.service';
import { AutoDepartmentFilterService } from 'src/app/core/services/auto-department-filter.service';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { BehaviorSubject, Observable } from 'rxjs';
import { DepartmentService } from '../../../../../../../core/services/department.service';
import { ErrorCode } from 'src/app/core/constants/error-code';

@Component({
  selector: 'app-update-department',
  templateUrl: './update-department.component.html',
  styleUrls: ['./update-department.component.scss']
})
export class UpdateDepartmentComponent implements OnInit, AfterViewInit, OnDestroy, DeactivationGuarded {
  isSavingData = false;

  userGroup = {
    idString: null,
    code: '',
    name: '',
    description: '',
    listUserInDepartment: [],
    representativeIdString: '',
    departmentType: null

  };
  change = false;
  checkEscKey = false;
  isFormChanging = false;
  formChangesSubscription: Subscription;
  checkFocus = true;

  @ViewChild('f', { static: false }) ngForm: NgForm;
  @ViewChildren('focusInput') focusInput;
  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event) {
    if (!this.checkEscKey) {
      this.onClickBtnCancel();
    }
  }
  @HostListener('submit')
  onFormSubmit() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.mat-form-field-invalid .mat-input-element,.mat-select-invalid');
    if (invalidElements.length > 0) {
      invalidElements[0].focus();
    }
  }
  constructor(
    private apiService: ApiService,
    private el: ElementRef,
    private sv: UserGroupService,
    private dialogRef: MatDialogRef<UpdateDepartmentComponent>,
    private dialog: MatDialog,
    public notificationService: NotificationService,
    private message: Message,
    private toastr: ToastrService,
    public commonService: CommonService,
    private renderer: Renderer2,
    private departmentService: DepartmentService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    dialogRef.disableClose = true;
    dialogRef.backdropClick().subscribe(_ => {
      this.onClickBtnCancel();
    });
  }

  ngOnInit() {
    this.userGroup.idString = this.data.idString;
    this.userGroup.code = this.data.code;
    this.userGroup.name = this.data.name;
    this.userGroup.description = this.data.description;
    this.userGroup.departmentType = this.data.departmentType;

  }

  ngAfterViewInit() {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
    this.formChangesSubscription = this.ngForm.form.statusChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.isFormChanging = true;
      }
    });
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.formChangesSubscription.unsubscribe();
    this.apiService.removeUrlToHandlingErrorRestApis();
  }

  /**
   * Create group user
   */
  onCreateGroup() {
    if (this.isSavingData) {
      return;
    }
    this.isSavingData = true;
    if (this.userGroup.representativeIdString === undefined) {
      this.userGroup.representativeIdString = null;
    }
    this.departmentService.updateDepartment(this.userGroup).subscribe(res => {
      if (res.success) {
        // if (res.data === "code_already_exist") {
        //   this.isSavingData = false;
        //   this.toastr.error(this.message.getMessage('validation.err_department_code_duplicate'));
        // } else if (res.data === "name_already_exist") {
        //   this.isSavingData = false;
        //   this.toastr.error(this.message.getMessage('validation.err_department_name_duplicate'));
        // } else {
          this.toastr.success(this.message.getMessage('messages.update_department'));
          this.dialogRef.close(true);
        // }
      } else if (res.code === ErrorCode.DataNotfound){
        this.toastr.error(this.message.getMessage('messages.update_department_not_found'));
        this.dialogRef.close(true);
      } else {
        this.isSavingData = false;
        this.toastr.error(res.message);
      }
    }
    // , err => {
    //   this.isSavingData = false;
    // }
    );
  }

  /**
   * Event when click button cancel
   */
  onClickBtnCancel() {
    if ((this.isFormChanging || this.change)) {
      this.checkEscKey = true;
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close();
        }
        dialogRe.close();
        this.checkEscKey = false;
      });
    } else {
      this.dialogRef.close();
    }
  }

  /**
   * Confirm before navigation
   */
  canDeactivate() {
    if (!this.isFormChanging) {
      return true;
    } else {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      return dialogRe.afterClosed().pipe(map(result => {
        if (result) {
          return true;
        } else {
          return false;
        }
      }), first());
    }
  }

  // Function handler set sự thay đổi trên form.
  setFormChanging(changingStatus: boolean): void {
    this.isFormChanging = changingStatus;
  }

}
